import { accountDiscoveryTypes } from 'app-components/flux/account-discovery';
import { DIALOG_TYPE_NPS_SURVEY } from 'app-components/flux/nps';

import AccountDiscoveryDialog from 'components/Dialogs/AccountDiscovery';
import ReauthDialog from 'components/Dialogs/AccountDiscovery/ReauthDialog';
import { REAUTHENTICATION_DIALOG } from 'components/Dialogs/AccountDiscovery/ReauthDialog/dispatcher';
import AccountEditDialog, { DIALOG_TYPE_ACCOUNT_EDIT } from 'components/Dialogs/AccountEditDialog';
import AccountLockoutDialog from 'components/Dialogs/A2A/AccountLockoutDialog';
import AccountTransfersDialog from 'components/Dialogs/A2A/AccountTransfersDialog';
import {
  DIALOG_TYPE_ACCOUNTS_TRANSFERS,
  DIALOG_TYPE_FUNDING_ACCOUNT_LOCKOUT,
  DIALOG_TYPE_MICRODEPOSIT_CONFIRMATION_FOR_TRANSFERS,
  DIALOG_TYPE_ONBOARD_ACCOUNTS_FOR_TRANSFERS,
  DIALOG_TYPE_TRANSFER_ACTIVITY_DETAILS,
} from 'components/Dialogs/A2A/actions';
import MicrodepositConfirmationDialog from 'components/Dialogs/A2A/MicrodepositConfirmationDialog';
import OnboardAccountsForTransfersDialog from 'components/Dialogs/A2A/OnboardAccountsForTransfers';
import TransferActivityDetails from 'components/Dialogs/A2A/TransferActivityDetails';
import AlertDialog from 'components/Dialogs/AlertDialog';
import { DIALOG_TYPE as DIALOG_TYPE_ALERT } from 'components/Dialogs/AlertDialog/types';
import AssetDialog from 'components/Dialogs/AssetDialog';
import { DIALOG_TYPE_ASSET } from 'components/Dialogs/AssetDialog/actions';
import BillPresentmentDialog from 'components/Dialogs/BillPresentment';
import BillPresentmentDetailsDialog from 'components/Dialogs/BillPresentment/BillPresentmentDetailsDialog';
import {
  DETAILS_DIALOG_TYPE as DIALOG_TYPE_BILL_PRESENTMENT_DETAILS,
  DIALOG_TYPE as DIALOG_TYPE_BILL_PRESENTMENT,
} from 'components/Dialogs/BillPresentment/actions';
import BillScoutDialog from 'components/Dialogs/BillScout';
import { DIALOG_TYPE as DIALOG_TYPE_BILL_SCOUT } from 'components/Dialogs/BillScout/actions';
import CancelTransactionRuleDialog from 'components/Dialogs/CancelTransactionRule';
import { DIALOG_TYPE as DIALOG_TYPE_CANCEL_TRANSACTION_RULE } from 'components/Dialogs/CancelTransactionRule/actions';
import ConfirmationDialog, { DIALOG_TYPE as DIALOG_TYPE_CONFIRMATION } from 'components/Dialogs/ConfirmationDialog';
import CreditReportCancelRegistrationDialog from 'components/Dialogs/CreditScore/CancelRegistrationDialog';
import CreditReportUpdateDialog from 'components/Dialogs/CreditScore/CreditReportUpdateDialog';
import {
  DIALOG_TYPE_CANCEL_REGISTRATION,
  DIALOG_TYPE_CREDIT_REPORT_UPDATE,
  DIALOG_TYPE_CREDIT_SCORE_LOADING,
  DIALOG_TYPE_CREDIT_SCORE_REGISTER,
  DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_EVENTS,
  DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_SENT,
} from 'components/Dialogs/CreditScore/actions';
import CreditScoreRegistrationDialog from 'components/Dialogs/CreditScore/CreditScoreRegistrationDialog';
import CreditScoreVerificationEventsDialog from 'components/Dialogs/CreditScore/CreditScoreVerificationEventsDialog';
import CreditScoreVerificationSentDialog from 'components/Dialogs/CreditScore/CreditScoreVerificationSentDialog';
import CreditScoreVerificationLoadingDialog from 'components/Dialogs/CreditScore/LoadingDialog';
import DeletePlannedSpending from 'components/Dialogs/DeletePlannedSpending';
import { DIALOG_TYPE as DIALOG_TYPE_PLANNED_SPENDING_DELETE } from 'components/Dialogs/DeletePlannedSpending/actions';
import DeleteReminderDialog from 'components/Dialogs/DeleteReminderDialog';
import { DIALOG_TYPE as DIALOG_TYPE_DELETE_REMINDER } from 'components/Dialogs/DeleteReminderDialog/actions';
import DeleteTransactionRuleDialog from 'components/Dialogs/DeleteTransactionRule';
import { DIALOG_TYPE as DIALOG_TYPE_DELETE_TRANSACTION_RULE } from 'components/Dialogs/DeleteTransactionRule/actions';
import EditReminderDialog from 'components/Dialogs/EditReminderDialog';
import { DIALOG_TYPE as DIALOG_TYPE_EDIT_REMINDER } from 'components/Dialogs/EditReminderDialog/actions';
import EditPlannedSpending from 'components/Dialogs/EditPlannedSpending';
import { DIALOG_TYPE as DIALOG_TYPE_PLANNED_SPENDING_EDIT } from 'components/Dialogs/EditPlannedSpending/actions';
import EditPlannedSpendingInstance from 'components/Dialogs/EditPlannedSpendingInstance';
import { DIALOG_TYPE as EDIT_PLANNED_SPENDING_INSTANCE_DIALOG } from 'components/Dialogs/EditPlannedSpendingInstance/actions';
import EditPlannedSpendingSeries from 'components/Dialogs/EditPlannedSpendingSeries';
import { DIALOG_TYPE as EDIT_PLANNED_SPENDING_SERIES_DIALOG } from 'components/Dialogs/EditPlannedSpendingSeries/actions';
import EmailVerificationDialog, { DIALOG_TYPE_EMAIL_VERIFICATION_DIALOG } from 'components/Dialogs/EmailVerification';
import EmptyDialog, { DIALOG_TYPE_EMPTY_DIALOG } from 'components/Dialogs/EmptyDialog';
import { DIALOG_TYPE as DIALOG_TYPE_FIRST_USE_V2 } from 'components/Dialogs/FirstTimeUse/spendingPlanFirstUseV2/actions';
import SpendingPlanFirstUseV2 from 'components/Dialogs/FirstTimeUse/spendingPlanFirstUseV2/spendingPlanFirstUseV2';
import WatchlistFirstUse from 'components/Dialogs/FirstTimeUse/watchlistFirstUse';
import { DIALOG_TYPE as DIALOG_TYPE_SWL_FIRST_USE } from 'components/Dialogs/FirstTimeUse/watchlistFirstUse/actions';
import FormDialog from 'components/Dialogs/FormDialog';
import { DIALOG_TYPE as DIALOG_TYPE_FORM } from 'components/Dialogs/FormDialog/types';
import AddGoal from 'components/Dialogs/Goals/AddGoal';
import {
  ADD_GOAL_DIALOG_TYPE as DIALOG_TYPE_ADD_GOAL,
  CONTRIBUTE_TO_GOAL_DIALOG_TYPE as DIALOG_TYPE_CONTRIBUTE_TO_GOAL,
  WITHDRAW_FROM_GOAL_DIALOG_TYPE as DIALOG_TYPE_WITHDRAW_FROM_GOAL,
} from 'components/Dialogs/Goals/actions';
import ContributeToGoal from 'components/Dialogs/Goals/ContributeToGoal';
import WithdrawFromGoal from 'components/Dialogs/Goals/WithdrawFromGoal';
import IdentityVerificationDialog, {
  DIALOG_TYPE_IDENTITY_VERIFICATION_DIALOG,
} from 'components/Dialogs/IdentityVerification';
import InvestmentTransactionEditDialog, {
  DIALOG_TYPE_INVESTMENT_TRANSACTIONS_EDIT,
} from 'components/Dialogs/InvestmentTransactionEditDialog';
import LlmGoalDialog, { DIALOG_TYPE_LLM_GOAL } from 'components/Dialogs/LlmGoalDialog';
import LlmGoalContributionDialog, {
  DIALOG_TYPE_LLM_GOAL_CONTRIBUTE,
} from 'components/Dialogs/LlmGoalContributionDialog';
import LlmRecurringDialog, { DIALOG_TYPE_LLM_RECURRING } from 'components/Dialogs/LlmRecurringDialog';
import LlmRuleDialog, { DIALOG_TYPE_LLM_RULE } from 'components/Dialogs/LlmRuleDialog';
import LlmTransactionDialog, { DIALOG_TYPE_LLM_TRANSACTION } from 'components/Dialogs/LlmTransactionDialog';
import LlmWatchlistDialog, { DIALOG_TYPE_LLM_WATCHLIST } from 'components/Dialogs/LlmWatchlistDialog';
import ManageUpdatesDialog from 'components/Dialogs/ManageUpdatesDialog';
import { MANAGE_UPDATES_DIALOG } from 'components/Dialogs/ManageUpdatesDialog/dispatcher';
import MatchTxnDialog from 'components/Dialogs/MatchTxnDialog';
import { DIALOG_TYPE as DIALOG_TYPE_MATCH_TXN } from 'components/Dialogs/MatchTxnDialog/actions';
import NotificationDialog from 'components/Dialogs/NotificationDialog';
import { DIALOG_TYPE as DIALOG_TYPE_NOTIFICATION } from 'components/Dialogs/NotificationDialog/types';
import NPSSurveyDialog from 'components/Dialogs/NPSSurveyDialog';
import AddPlannedSpending from 'components/Dialogs/AddPlannedSpending';
import { DIALOG_TYPE as DIALOG_TYPE_PLANNED_SPENDING } from 'components/Dialogs/AddPlannedSpending/actions';
import PhoneVerificationDialog, { DIALOG_TYPE_PHONE_VERIFICATION_DIALOG } from 'components/Dialogs/PhoneVerification';
import RefreshTimeoutDialog, {
  DIALOG_TYPE as DIALOG_TYPE_REFRESH_TIMEOUT,
} from 'components/Dialogs/RefreshTimeoutDialog';
import RefundEditDialog, { DIALOG_TYPE_REFUND_EDIT } from 'components/Dialogs/RefundEditDialog';
import RefundMatchDialog, { DIALOG_TYPE_REFUND_MATCH } from 'components/Dialogs/RefundMatchDialog';
import ReportErrorDialog, { DIALOG_TYPE_REPORT_ERROR } from 'components/Dialogs/ReportErrorDialog';
import ReviewLlmCategoriesDialog, {
  DIALOG_TYPE_REVIEW_CATEGORY,
} from 'components/Dialogs/ReviewLlmCatagoriesDialog.tsx';
import { DIALOG_TYPE_REVIEW_RENAME_PAYEE } from 'components/Dialogs/ReviewRenamePayeeDialog/actions';
import ScheduledTransactionAddDialog from 'components/Dialogs/ScheduledTransactionAddDialog';
import { DIALOG_TYPE as DIALOG_TYPE_SCHEDULED_TRANSACTION_ADD } from 'components/Dialogs/ScheduledTransactionAddDialog/actions';
import ScheduledTransactionEditDialog, {
  DIALOG_TYPE as DIALOG_TYPE_SCHEDULED_TRANSACTION_EDIT,
} from 'components/Dialogs/ScheduledTransactionEditDialog';
import SecurityEditDialog, { DIALOG_TYPE_SECURITY_EDIT } from 'components/Dialogs/SecurityEditDialog';
import TransactionRulesDialog from 'components/Dialogs/TransactionRules';
import { DIALOG_TYPE as DIALOG_TYPE_MEMORIZED_RULE_EDIT } from 'components/Dialogs/TransactionRules/actions';
import TxnSettings from 'components/Dialogs/TransactionsSettingsDialog';
import { DIALOG_TYPE_TXN_SETTINGS } from 'components/Dialogs/TransactionsSettingsDialog/actions';
import ViewSeriesDialog from 'components/Dialogs/ViewSeriesDialog';
import { DIALOG_TYPE as DIALOG_TYPE_VIEW_SERIES } from 'components/Dialogs/ViewSeriesDialog/actions';
import WatchlistModal from 'components/Dialogs/WatchlistModal';
import { DIALOG_TYPE as DIALOG_TYPE_WATCHLIST } from 'components/Dialogs/WatchlistModal/actions';
import { DIALOG_TYPE as DIALOG_TYPE_COBROWSE_CODE_FETCH } from 'components/Dialogs/CobrowseCodeFetch/actions';
import { INVOICE_PAYMENT_ROOTUI_TYPE } from 'components/InvoicePayment/actions';
import { MATCH_SALES_RECEIPT_ROOTUI_TYPE } from 'components/ReceiptMatch/actions';
import TransactionEditDialog from 'components/Dialogs/TransactionEditDialog';
import { DIALOG_TYPE as DIALOG_TYPE_TRANSACTION_DETAILS } from 'components/Dialogs/TransactionEditDialog/actions';
import SplitDialog from 'components/Transactions/SplitDialog';
import { DIALOG_TYPE as DIALOG_TYPE_SPLIT_DIALOG } from 'components/Transactions/SplitDialog/actions';

import { ImportModalComponent, RegisterModalComponent } from './modalRegistry';

// shared
RegisterModalComponent(DIALOG_TYPE_LLM_GOAL, LlmGoalDialog);
RegisterModalComponent(DIALOG_TYPE_LLM_GOAL_CONTRIBUTE, LlmGoalContributionDialog);
RegisterModalComponent(DIALOG_TYPE_LLM_RECURRING, LlmRecurringDialog);
RegisterModalComponent(DIALOG_TYPE_LLM_RULE, LlmRuleDialog);
RegisterModalComponent(DIALOG_TYPE_LLM_TRANSACTION, LlmTransactionDialog);
RegisterModalComponent(DIALOG_TYPE_LLM_WATCHLIST, LlmWatchlistDialog);
RegisterModalComponent(DIALOG_TYPE_REVIEW_CATEGORY, ReviewLlmCategoriesDialog);
ImportModalComponent(DIALOG_TYPE_REVIEW_RENAME_PAYEE, () => import('components/Dialogs/ReviewRenamePayeeDialog'), {
  rootModalDrawer: { width: 'Medium' },
});
RegisterModalComponent(DIALOG_TYPE_TXN_SETTINGS, TxnSettings);
RegisterModalComponent(accountDiscoveryTypes.DIALOG_TYPE_ACCOUNTS_DISCOVERY, AccountDiscoveryDialog);
RegisterModalComponent(DIALOG_TYPE_ALERT, AlertDialog);
RegisterModalComponent(DIALOG_TYPE_ASSET, AssetDialog);
RegisterModalComponent(DIALOG_TYPE_CONFIRMATION, ConfirmationDialog);
RegisterModalComponent(DIALOG_TYPE_FORM, FormDialog);
RegisterModalComponent(DIALOG_TYPE_NOTIFICATION, NotificationDialog);
RegisterModalComponent(DIALOG_TYPE_REFRESH_TIMEOUT, RefreshTimeoutDialog);
RegisterModalComponent(DIALOG_TYPE_NPS_SURVEY, NPSSurveyDialog);
RegisterModalComponent(DIALOG_TYPE_ADD_GOAL, AddGoal);
RegisterModalComponent(DIALOG_TYPE_WITHDRAW_FROM_GOAL, WithdrawFromGoal);
RegisterModalComponent(DIALOG_TYPE_CONTRIBUTE_TO_GOAL, ContributeToGoal);
RegisterModalComponent(DIALOG_TYPE_FIRST_USE_V2, SpendingPlanFirstUseV2);
RegisterModalComponent(DIALOG_TYPE_SWL_FIRST_USE, WatchlistFirstUse);
RegisterModalComponent(DIALOG_TYPE_WATCHLIST, WatchlistModal);
RegisterModalComponent(DIALOG_TYPE_ONBOARD_ACCOUNTS_FOR_TRANSFERS, OnboardAccountsForTransfersDialog);
RegisterModalComponent(DIALOG_TYPE_MICRODEPOSIT_CONFIRMATION_FOR_TRANSFERS, MicrodepositConfirmationDialog);
RegisterModalComponent(DIALOG_TYPE_FUNDING_ACCOUNT_LOCKOUT, AccountLockoutDialog);
RegisterModalComponent(DIALOG_TYPE_ACCOUNTS_TRANSFERS, AccountTransfersDialog);
RegisterModalComponent(DIALOG_TYPE_TRANSFER_ACTIVITY_DETAILS, TransferActivityDetails);
RegisterModalComponent(DIALOG_TYPE_INVESTMENT_TRANSACTIONS_EDIT, InvestmentTransactionEditDialog, {
  rootModalDrawer: { width: 'Large' },
});
RegisterModalComponent(DIALOG_TYPE_SECURITY_EDIT, SecurityEditDialog);
RegisterModalComponent(DIALOG_TYPE_DELETE_REMINDER, DeleteReminderDialog);
RegisterModalComponent(DIALOG_TYPE_DELETE_TRANSACTION_RULE, DeleteTransactionRuleDialog);
RegisterModalComponent(DIALOG_TYPE_CANCEL_TRANSACTION_RULE, CancelTransactionRuleDialog);
RegisterModalComponent(DIALOG_TYPE_MATCH_TXN, MatchTxnDialog, { rootModalDrawer: { width: 'Large' } });
RegisterModalComponent(DIALOG_TYPE_PLANNED_SPENDING, AddPlannedSpending);
RegisterModalComponent(DIALOG_TYPE_PLANNED_SPENDING_EDIT, EditPlannedSpending);
RegisterModalComponent(EDIT_PLANNED_SPENDING_INSTANCE_DIALOG, EditPlannedSpendingInstance);
RegisterModalComponent(EDIT_PLANNED_SPENDING_SERIES_DIALOG, EditPlannedSpendingSeries);
RegisterModalComponent(DIALOG_TYPE_PLANNED_SPENDING_DELETE, DeletePlannedSpending);
RegisterModalComponent(DIALOG_TYPE_EDIT_REMINDER, EditReminderDialog, { rootModalDrawer: { width: 'Large' } });
RegisterModalComponent(DIALOG_TYPE_VIEW_SERIES, ViewSeriesDialog, { rootModalDrawer: { width: 'Large' } });
RegisterModalComponent(DIALOG_TYPE_BILL_PRESENTMENT, BillPresentmentDialog);
RegisterModalComponent(DIALOG_TYPE_BILL_PRESENTMENT_DETAILS, BillPresentmentDetailsDialog);
RegisterModalComponent(DIALOG_TYPE_BILL_SCOUT, BillScoutDialog);
RegisterModalComponent(DIALOG_TYPE_REFUND_EDIT, RefundEditDialog, { rootModalDrawer: { width: 'Large' } });
RegisterModalComponent(DIALOG_TYPE_REFUND_MATCH, RefundMatchDialog);
RegisterModalComponent(DIALOG_TYPE_SCHEDULED_TRANSACTION_ADD, ScheduledTransactionAddDialog, {
  rootModalDrawer: { width: 'Large' },
});
RegisterModalComponent(DIALOG_TYPE_MEMORIZED_RULE_EDIT, TransactionRulesDialog);
RegisterModalComponent(DIALOG_TYPE_EMPTY_DIALOG, EmptyDialog);
RegisterModalComponent(DIALOG_TYPE_REPORT_ERROR, ReportErrorDialog);
RegisterModalComponent(DIALOG_TYPE_ACCOUNT_EDIT, AccountEditDialog);
RegisterModalComponent(DIALOG_TYPE_IDENTITY_VERIFICATION_DIALOG, IdentityVerificationDialog);
RegisterModalComponent(DIALOG_TYPE_TRANSACTION_DETAILS, TransactionEditDialog, {
  // Opens at the previous 'Large' width; the enhanced skinny view narrows it to 'Small' at render
  // time (via the view model's width rebroadcast) when transactionsEnhancedDetailViewRelease is on.
  rootModalDrawer: { width: 'Large', showScrim: true },
});
RegisterModalComponent(DIALOG_TYPE_SPLIT_DIALOG, SplitDialog);
RegisterModalComponent(DIALOG_TYPE_SCHEDULED_TRANSACTION_EDIT, ScheduledTransactionEditDialog);
RegisterModalComponent(DIALOG_TYPE_PHONE_VERIFICATION_DIALOG, PhoneVerificationDialog);
RegisterModalComponent(DIALOG_TYPE_EMAIL_VERIFICATION_DIALOG, EmailVerificationDialog);
RegisterModalComponent(DIALOG_TYPE_CREDIT_SCORE_REGISTER, CreditScoreRegistrationDialog);
RegisterModalComponent(DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_SENT, CreditScoreVerificationSentDialog);
RegisterModalComponent(DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_EVENTS, CreditScoreVerificationEventsDialog);
RegisterModalComponent(DIALOG_TYPE_CREDIT_SCORE_LOADING, CreditScoreVerificationLoadingDialog);
RegisterModalComponent(DIALOG_TYPE_CREDIT_REPORT_UPDATE, CreditReportUpdateDialog);
RegisterModalComponent(DIALOG_TYPE_CANCEL_REGISTRATION, CreditReportCancelRegistrationDialog);
RegisterModalComponent(MANAGE_UPDATES_DIALOG, ManageUpdatesDialog);
RegisterModalComponent(REAUTHENTICATION_DIALOG, ReauthDialog);
ImportModalComponent(DIALOG_TYPE_COBROWSE_CODE_FETCH, () => import('components/Dialogs/CobrowseCodeFetch'));
// Invoice payment renders its own StdDialog, so it must never be promoted to an
// overlay drawer shell when launched from a drawer — the dialog portals back out
// to document.body and the shell is left drawing nothing but its own paper and
// edge over whatever is below. Same reason InvoiceForm pins itself to the modal
// presentation path.
ImportModalComponent(INVOICE_PAYMENT_ROOTUI_TYPE, () => import('components/InvoicePayment'), {
  rootModalPresentation: 'modal',
});
ImportModalComponent(MATCH_SALES_RECEIPT_ROOTUI_TYPE, () => import('components/ReceiptMatch/MatchSalesReceipt'));
